<template>
  <v-select
      :items="options"
      v-model="priority"
      outlined
      hide-details="auto"
      :rules="rules"
      style="max-width: 15em"
  ></v-select>
</template>

<script>
export default {
  name: 'ServiceStateSelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    priority: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    options() {
      const statuses = [
        'ASSIGNED',
        'IN_PROGRESS_USABLE',
        'SCHEDULED_IN_DEVELOPMENT',
        'IN_PROGRESS_UNAVAILABLE',
        'FIXED',
        'LEFT_UNDONE',
        'INVALID'];

      return statuses.map(status => {
        return {
          text: this.$options.filters.serviceState(status),
          value: status,
        };
      });
    },
  },
};
</script>
